import * as React from 'react';
import { Chips } from '@cian/ui-kit';

import { TInfrastructurePoiType } from '../../../../types/infrastructure';
import { INFRASTRUCTURE_ICON_MAP, INFRASTRUCTURE_TITLE_MAP } from '../../constants';
import * as styles from './styles.css';

export interface ITypeFiltersProps {
  /** Типы, доступные для фильтрации — только реально присутствующие среди загруженных точек. */
  types: TInfrastructurePoiType[];
  activeTypes: TInfrastructurePoiType[];
  /** Типы, отмеченные зелёной точкой — в режиме будущего у них появляются новые объекты. */
  badgeTypes?: TInfrastructurePoiType[];
  onChange(activeTypes: TInfrastructurePoiType[]): void;
  /** Клик по конкретному чипсу — для аналитики. */
  onTypeClick?(type: TInfrastructurePoiType): void;
}

/** Чипсы-фильтры типов инфраструктуры поверх карты района. */
export function TypeFilters({
  types,
  activeTypes,
  badgeTypes,
  onChange,
  onTypeClick,
}: ITypeFiltersProps): React.JSX.Element | null {
  const options = React.useMemo(
    () =>
      types.map(type => {
        const Icon = INFRASTRUCTURE_ICON_MAP[type];

        return {
          dataTestId: `district-infrastructure-map-filter-${type}`,
          icon: badgeTypes?.includes(type) ? (
            <span className={styles['badge']} data-testid={`district-infrastructure-map-filter-badge-${type}`} />
          ) : undefined,
          label: INFRASTRUCTURE_TITLE_MAP[type],
          leftIcon: <Icon />,
          value: type,
        };
      }),
    [badgeTypes, types],
  );

  if (!types.length) {
    return null;
  }

  return (
    <div className={styles['container']} data-testid="district-infrastructure-map-filters">
      <Chips<TInfrastructurePoiType>
        inline
        scrollable
        options={options}
        selectType="multiple"
        value={activeTypes}
        onChange={onChange}
        onChipClick={onTypeClick}
      />
    </div>
  );
}
